
<template>
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
       {{actionToBePerformed}}
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li><router-link to="/nudge-template/view">Back</router-link></li>        
        <li class="active">{{actionToBePerformed}}</li>
      </ol>
    </section>

    <section class="content">
        <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="col-xs-12 col-md-12 col-lg-12">
                <form @submit.prevent="createOrUpdateNudge" action="#"  method="post">

                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group col-xs-6 col-sm-6 col-md-6" style="padding: 0px">
                            <label for="template_title" class="required">Template Title</label>
                            <input type="text" v-bind:class="{'form-group--error': submitted && !$v.template_title.required }" v-model="template_title" class="form-control" id="template_title" placeholder="Template Name"  />
                            <span v-if="submitted && !$v.template_title.required" class="text-red pull-right">Please enter template name.</span>
                          </div>
                          <div class="form-group col-xs-6 col-sm-6 col-md-6">
                            <label for="turn_country">WhatsApp Account (Country)</label>
                            <nv-select class="form-control" id="turn_country" v-model="turnCountry" v-on:change="onTurnCountryChange()">
                              <option v-for="country in countryList" :key="country" :value="country">{{country}}</option>
                            </nv-select>
                            <span class="help-block">Each country uses its own Turn namespace, so the approved templates below differ per country.</span>
                          </div>
                        </div>
                      </div>

                          <div class="panel panel-default" style="margin-top: 10px">
                            <div class="panel-heading">
                              <h3 class="panel-title">Match Template & Content</h3>
                            </div>
                            <div class="panel-body">
                              <div class="row">
                                <div class="col-md-12 col-lg-12 col-xs-12">

                                  <div class="form-group col-xs-4 col-sm-4 col-md-4">
                                    <label for="name" class="required">Language</label>
                                    <nv-select class="form-control" v-model="nudgeSet.language_id"  v-bind:class="{'form-group--error': addOrUpdateSubmit && !nudgeSet.language_id}">
                                      <option value="">--Choose language--</option>
                                      <option v-for="(value, index) in languages" :key="index" :value="value.id">
                                        {{value.full_name}}</option>
                                    </nv-select>
                                    <span v-if="addOrUpdateSubmit && !nudgeSet.language_id" class="text-red pull-right">Please select language.</span>

                                  </div>

                                  <div class="form-group col-xs-4 col-sm-4 col-md-4">
                                    <label for="turn_template_name" class="required">WhatsApp Turn template name</label>
                                    <treeselect
                                    v-bind:class="{'form-group--error': addOrUpdateSubmit && !nudgeSet.turn_template_name }"
                                    placeholder="--Choose a template--" 
                                    :multiple="false"
                                    :options="turnTemplateList" 
                                    v-model="nudgeSet.turn_template_name" />
                                    <div class="display-content">
                                      <label class="checkbox-inline">
                                        <input type="checkbox" v-model="nudgeSet.is_dynamic_template" />
                                          <b>Is Dynamic Template?</b>
                                          <span title="Ensure that this option is checked only if the template is dynamic, as it will replace the arguments in the message with the actual text that we provide during configuration"><i class="fa fa-info-circle margin-10"></i></span>
                                      </label>
                                    </div>

                                    <div class="display-content" v-if="checkIfTemplateHasMedia(nudgeSet.turn_template_name)">
                                      <label for="media_id" class="required">Select Uploaded Media</label>
                                        <treeselect
                                        v-bind:class="{'form-group--error': addOrUpdateSubmit && !nudgeSet.media_id }"
                                        placeholder="--Choose a media--" 
                                        :multiple="false"
                                        :options="mediaList" 
                                        v-model="nudgeSet.media_id" />
                                      <!-- The picked file itself, so the right one is attached. -->
                                      <media-preview
                                        v-if="nudgeSet.media_id"
                                        compact
                                        :format="mediaFormatOf(nudgeSet.media_id) || headerFormatOf(nudgeSet.turn_template_name)"
                                        :media-id="nudgeSet.media_id"
                                        :media-name="mediaLabel(nudgeSet.media_id)"
                                        missing-text=": no stored file"
                                      />
                                      <span v-if="mediaMismatch(nudgeSet)" class="text-red">{{ mediaMismatch(nudgeSet) }}</span>
                                    </div>

                                    <div class="display-content" v-if="nudgeSet.turn_template_name">
                                      <b>Content: </b>
                                      <span>{{getTurnDisplayText(nudgeSet.turn_template_name)}}</span>
                                    </div>
                                    <span v-if="addOrUpdateSubmit && !nudgeSet.turn_template_name" class="text-red pull-right">Please enter turn template name.</span>
                                  </div>

                                  <div class="col-md-4 col-lg-4 col-xs-4">
                                    <label for="legacy_name" class="required">Facebook Nudge Content</label>
                                    <div class="fb-nudge-container">
                                      <span class="fb-nudge-text">Title: </span>
                                      <input style='margin-bottom: 10px' type="text" v-model="nudgeSet.fb_nudge_title" class="form-control" id="legacy_name" placeholder="Enter Title"  />
                                    </div>
                                    <div class="fb-nudge-container">
                                      <span class="fb-nudge-text">Image Url: </span>
                                      <input style='margin-bottom: 10px' type="text" v-model="nudgeSet.fb_nudge_image" class="form-control" id="legacy_name" placeholder="Enter Image URL"  />
                                    </div>
                                    <div class="fb-nudge-container">
                                      <span class="fb-nudge-text required">Body: </span>
                                      <div style="display: flex; flex-direction: column; width: 100%">
                                        <textarea class="form-control" v-bind:class="{'form-group--error': addOrUpdateSubmit && !nudgeSet.fb_nudge_text}" v-model="nudgeSet.fb_nudge_text" placeholder="Enter Body text" />
                                        <span v-if="addOrUpdateSubmit && !nudgeSet.fb_nudge_text" class="text-red pull-right" style="align-self: end;">Please enter Facebook body text.</span>
                                      </div>

                                    </div>
                                  </div>

                                </div>
                              </div>


                              <div class="action-button" style="margin: 25px">
                                <input type="button" v-on:click="addOrUpdateText()" class="btn btn-success btn-sm" :value="nudge_btn_text" />
                              </div>


                              <table v-if="nudges.length" class="table table-striped margin-top-20">
                                <thead>
                                  <th class="width-100">Language</th>
                                  <th>WhatsApp Approved Templates</th>
                                  <th>Facebook Messenger Content</th>
                                  <th class="align-center">Edit</th>
                                  <th class="align-center">Delete</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(nudge, key) in nudges" :key="key">
                                      <td style="width:10%; background-color: #e8e8e8;">
                                        <h4><strong>{{languages.find(item => item.id === nudge.language_id).full_name}}</strong></h4>
                                      </td>
                                      <td style="width:40%">
                                        <span class="fb-nudge-text">Name: </span> {{nudge.turn_template_name}}
                                        <span class="fb-nudge-text">Dynamic: </span> {{nudge.is_dynamic_template ? 'Yes' : 'No'}}
                                        <span class="fb-nudge-text">Media: </span> {{nudge.media_id ? mediaLabel(nudge.media_id) : 'No Media'}}
                                        <media-preview
                                          v-if="nudge.media_id"
                                          compact
                                          :show-caption="false"
                                          :format="mediaFormatOf(nudge.media_id) || headerFormatOf(nudge.turn_template_name)"
                                          :media-id="nudge.media_id"
                                          :media-name="mediaLabel(nudge.media_id)"
                                          missing-text=": no stored file"
                                        />
                                        <span class="fb-nudge-text">Content: </span> {{getTurnDisplayText(nudge.turn_template_name)}}
                                      </td>
                                      <td style="width:40%"> <span class="fb-nudge-text">Title: </span> {{nudge.fb_nudge_title}}
                                        <span class="fb-nudge-text">Image: </span> {{nudge.fb_nudge_image}}
                                        <span class="fb-nudge-text">Body: </span> {{nudge.fb_nudge_text}}
                                      </td>
                                  
                                      <td style="width:5%;" class="align-center"><i class="fa fa fa-pencil" v-on:click="editNudge(key)"
                                          aria-hidden="true"></i></td>
                                      <td style="width:5%" class="align-center"><i class="fa fa-times-circle"
                                          v-on:click="deleteNudge(key)" aria-hidden="true"></i></td>
                                    </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>


                  <div class="row">
                  </div>
                  <div class="row">
                    <div class="action-button">
                      <button type="button" class="btn btn-primary" @click="close">Cancel</button>
                      <input type="submit" class="btn btn-primary margin-left-20px" :value="template_id ? 'Update Nudge' : 'Save Nudge' ">
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div> 
        </div>
      </div>

    </section>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
    </div>
</template>
<script>
  import { required } from 'vuelidate/lib/validators'
  import api from '../../../utils/api'
  import MediaPreview from '../common/MediaPreview.vue'
  export default {
    name: 'modal',
    components: { MediaPreview },
    validations: {
      template_title: {required}
    },
    data () {
      return {
        mediaList: [],
        turnTemplateList: [],
        loading: false,
        submitted: false,
        actionToBePerformed: 'Create Nudge Template',
        languages: [],
        countryList: [],
        turnCountry: '',
        template_id: null,
        template_title: '',
        nudges: [],
        nudgeSet: {
          language_id: '',
          turn_template_name: null,
          is_dynamic_template: false,
          media_id: null,
          fb_nudge_text: '',
          fb_nudge_title: '',
          fb_nudge_image: ''
        },
        nudge_btn_text: 'Add Nudge Translation',
        editNudgeLang: '',
        addOrUpdateSubmit: false,
        turnTemplates: null
      }
    },
    methods: {
      close () {
        this.$router.replace('/nudge-template/view')
      },
      async getTurnCountryList () {
        try {
          const response = await api.buildRequest('getQuickLinkConfig', 'POST')
          const whatsapp = (response.data.payload && response.data.payload.whatsapp) || {}
          this.countryList = Object.keys(whatsapp)
          if (!this.turnCountry && this.countryList.length) {
            this.turnCountry = this.countryList[0]
          }
        } catch (error) {
          console.error('Failed to fetch WhatsApp country list', error)
        }
      },
      async onTurnCountryChange () {
        await this.getTurnTemplateData()
      },
      async getTurnTemplateData () {
        try {
          this.loading = true
          this.turnTemplateList = []
          const response = await api.buildRequest('getTurnTemplateData', 'GET', { country: this.turnCountry })
          let resp = response.data.payload
          for (let list in resp) {
            this.turnTemplateList.push({id: resp[list].name, label: resp[list].name})
          }
          this.turnTemplates = resp
          this.loading = false
        } catch (error) {
          this.loading = false
          this.$swal({
            type: 'error',
            text: error.response ? error.response.data.payload.message : 'An error occurred'
          })
        }
      },
      getMediaList () {
        api.buildRequest('getAllMediaList', 'GET').then(({ data }) => {
          // media_type (image / video / document / audio) kept for the preview and the
          // header-type match below.
          this.mediaList = data.payload.map(media => { return { id: media.id, label: media.media_name, mediaType: media.media_type, mediaFormat: media.media_format } })
        })
      },
      getTurnDisplayText (templateName) {
        if (this.turnTemplates) {
          let obj = {}
          this.turnTemplates[templateName] && this.turnTemplates[templateName].components.forEach(msg => {
            obj[msg.type] = msg.text
          })

          let data = (obj['HEADER'] ? (obj['HEADER'] + '\n') : '') + obj['BODY'] + (obj['FOOTER'] ? ('\n' + obj['FOOTER']) : '')

          if (!data || data === 'undefined') {
            data = ` -- Not available in ${this.turnCountry} -- `
          }
          return data
        } else {
          return ` -- Not available in ${this.turnCountry} -- `
        }
      },
      // IMAGE / VIDEO / DOCUMENT from the Turn template's header, for MediaPreview.
      headerFormatOf (templateName) {
        const header = this.checkIfTemplateHasMedia(templateName)
        return (header && header.format) || 'IMAGE'
      },
      mediaFormatOf (mediaId) {
        const media = this.mediaList.find(item => item.id === mediaId)
        return media ? (media.mediaFormat || media.mediaType || '') : ''
      },
      // A picked file whose type doesn't match the template's header (a video on an IMAGE
      // header) is sent as the wrong type and fails, so it's flagged and blocks Save.
      mediaMismatch (nudge) {
        const header = this.checkIfTemplateHasMedia(nudge.turn_template_name)
        const media = this.mediaList.find(item => item.id === nudge.media_id)
        if (!header || !media || !media.mediaType) return ''
        const expected = { IMAGE: 'image', VIDEO: 'video', DOCUMENT: 'document' }[header.format]
        const actual = media.mediaType === 'application' ? 'document' : media.mediaType
        return expected && actual !== expected ? `"${media.label}" is ${actual === 'image' ? 'an image' : `a ${actual}`}, but this template's header is ${expected === 'image' ? 'an image' : `a ${expected}`}. Pick a matching file.` : ''
      },
      mediaLabel (mediaId) {
        const media = this.mediaList.find(item => item.id === mediaId)
        return media ? media.label : `Media #${mediaId}`
      },
      checkIfTemplateHasMedia (templateName) {
        if (this.turnTemplates) {
          return this.turnTemplates[templateName] && this.turnTemplates[templateName].components.find(msg => msg.type === 'HEADER' && ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(msg && msg.format))
        }
        return false
      },
      addOrUpdateText () {
        this.addOrUpdateSubmit = true

        if (!(this.nudgeSet.language_id && this.nudgeSet.turn_template_name && this.nudgeSet.fb_nudge_text)) {
          return
        } else if (this.mediaMismatch(this.nudgeSet)) {
          this.$swal({
            type: 'error',
            text: this.mediaMismatch(this.nudgeSet)
          })
          return
        } else if (this.checkIfTemplateHasMedia(this.nudgeSet.turn_template_name) && !this.nudgeSet.media_id) {
          this.$swal({
            type: 'error',
            text: 'Please select media for the template'
          })
          return
        } else {
          this.addOrUpdateSubmit = false
        }
        let removeIndex = this.nudges.findIndex(item => item.language_id === this.nudgeSet.language_id)
        if (this.editNudgeLang) {
          if (this.editNudgeLang !== this.nudgeSet.language_id) {
            let editnudgeIndex = this.nudges.findIndex(item => item.language_id === this.editNudgeLang)
            let currentLangIndex = this.nudges.findIndex(item => item.language_id === this.nudgeSet.language_id)
            this.nudges.splice(Math.max(editnudgeIndex, currentLangIndex), 1)
            removeIndex = Math.min(editnudgeIndex, currentLangIndex)
          } else {
            let editnudgeIndex = this.nudges.findIndex(item => item.language_id === this.editNudgeLang)
            removeIndex = editnudgeIndex
          }
          this.editNudgeLang = ''
        }
        if (removeIndex >= 0) this.nudges[removeIndex] = {...this.nudgeSet}
        else if (this.nudgeSet.language_id) {
          this.nudges.push({...this.nudgeSet})
        }
        this.nudgeSet = {
          language_id: '',
          turn_template_name: null,
          media_id: null,
          is_dynamic_template: false,
          fb_nudge_text: '',
          fb_nudge_title: '',
          fb_nudge_image: ''
        }
        this.nudge_btn_text = 'Add Nudge Translation'
      },
      editNudge (key) {
        this.nudge_btn_text = 'Update Nudge Translation'
        this.nudgeSet = {...this.nudges[key]}
        this.editNudgeLang = this.nudges[key].language_id
      },

      deleteNudge (key) {
        this.nudges.splice(key, 1)
      },
      async getAllSupportedLanguages () {
        try {
          this.loading = true
          const response = await api.buildRequest('getAllSupportedLanguages', 'POST')
          this.languages = response.data.payload
          this.loading = false
        } catch (error) {
          this.loading = false
          this.$swal({
            type: 'error',
            text: error.response ? error.response.data.payload.message : 'An error occurred'
          })
        }
      },

      async getNudgeDetails (id) {
        const param = {
          id: id
        }
        this.loading = true
        return new Promise(resolve => {
          api.buildRequest('getNudgeDetails', 'GET', param).then(async ({ data }) => {
            if (data && data.payload && data.payload) {
              this.template_title = data.payload.template_title
              this.nudges = data.payload.nudges
            }
            this.loading = false
            resolve(true)
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      async createOrUpdateNudge () {
        this.addOrUpdateSubmit = false
        this.submitted = true
        this.$v.template_title.$touch()
        if (this.$v.template_title.$invalid) {
          return
        }
        this.loading = true
        let param = {
          template_title: this.template_title,
          nudges: this.nudges
        }
        param.id = this.template_id

        if (param.id) {
          // -- call edit
          return new Promise(resolve => {
            api.buildRequest('updateNudgeTemplate', 'POST', param).then(() => {
              this.loading = false
              this.$swal({
                type: 'success',
                text: 'Nudge template updated successfully'
              }).then(() => {
                this.$router.push({ name: 'nudge-template/view' })
              })
              resolve()
            }).catch(({ response }) => {
              resolve(true)
              this.loading = false
              this.$swal({
                type: 'error',
                text: response ? response.data.payload.message : 'An error occurred'
              })
            })
          })
        } else {
          // -- call creat
          return new Promise(resolve => {
            api.buildRequest('createNudgeTemplate', 'POST', param).then(() => {
              this.loading = false
              this.$swal({
                type: 'success',
                text: 'Nudge template created successfully'
              }).then(() => {
                this.$router.push({ name: 'nudge-template/view' })
              })
              resolve()
            }).catch(({ response }) => {
              resolve(true)
              this.loading = false
              this.$swal({
                type: 'error',
                text: response ? response.data.payload.message : 'An error occurred'
              })
            })
          })
        }
      }
    },
    async mounted () {
      await this.getTurnCountryList()
      this.getTurnTemplateData()
      this.getAllSupportedLanguages()
      this.getMediaList()
      if (this.$route && this.$route.query && this.$route.query.nudgeTemplateId) {
        this.actionToBePerformed = 'Update Nudge Template'
        this.isEdit = true
        this.template_id = this.$route.query.nudgeTemplateId
        await this.getNudgeDetails(this.$route.query.nudgeTemplateId)
      }
      this.loading = false
    }
  }
</script>
<style>
.display-content{
  margin-top: 8px;
  white-space: pre-line;
}
.margin-top-20 {
  margin-top: 20px;
}
.width-100 {
  min-width: 100px;
}
.fb-nudge-container {
  display: flex;
}
.fb-nudge-text {
  margin-top: 8px;
  font-weight: bold;
  margin-right: 8px;
  width: 100px;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// createOrUpdateNudgeTemplate.vue?7f4cb5e8